export enum AppliancesTileTexts {
    TITLE = 'Geräte',
    LABEL_CONSUMPTION_IN= 'Verbrauch im'

}
